// extracted by mini-css-extract-plugin
export default {"mode":"Mode_mode__FCuFC","normal":"Mode_normal__SbSEA","insert":"Mode_insert__KkR0X","visual":"Mode_visual__Hg7ko"};